export const environment = {
    API_URL: 'https://pre.siafpplus.com.co',
    CW_HNP: '',
    CW_AUTH: '',
    CW_AFI: '',
    CW_HV: '',
    CW_HP: '',
    CW_DA: '',
    CW_UTILS: '',
    CW_HL: '',
    CW_PER: '',
    CW_MTS: '',
    CW_VIA: '',
    CW_GA: '',
    CW_CACHE: '',
    CW_BEN_PEN: '',
    CW_AUT_SER_AFI: '',
    CW_SAL_AFI: '',
    CW_GES_USU : '',
    CW_CHATBOT: '',
    encrypt: true,
    keyEcrypt: '1407f14e-898f-457b-8043-da0524cba1d0',
    publicKeyRSA: `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKxW0GBIpwR9//04XGpaRdDdHOqHdpox
    4seQq04BbKNZv3UEuP3vORIp338yfjD5is8CCi0jagt/JFVuEMdjmmMCAwEAAQ==`,
    URL_SIAFP: 'https://pre.siafp.com.co',
    SIAFP_WEB_IDLE_MINUTES: 10,
    SIAFP_WEB_AUTH_TIMEOUT_MS: 4000,
    SIAFP_WEB_TOAST_MS: 4000,
    SIAFP_WEB_AUTH_PATH: '/WEB-PortalAsofondos/PAG_INICIAL_AUTENTICAR_USUARIO_URL.do',
    URL_WIKI_SIAFP: 'https://10.125.15.2/wikisiafp/index.php/Usuario:P%C3%A1gina_principal',
    URL_REGISTRAR_SERVICIO: 'https://portalsoporte.heinsohn.com.co/asofondos',
    googleAnalyticsId : 'G-SKKHPYJT6W',
    /** PLUS-0097-H5: true = 4 flujos de preguntas; false = comportamiento previo a H5. */
    preguntasSeguridadHabilitadas: true
};
